/* eslint-disable @typescript-eslint/no-var-requires */

/**
 * Solanaland
 *
 * Author: Phia Nasol
 * Company: Digiteer Inc.
 *
 * https://www.digiteer.digital/
 *
 */

const importLazy = require("import-lazy")(require);

import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";
import "channels";
import I18n from "i18n-js";
import { collapseActiveNavigation, toggleSidebar, loadSidebarState } from "admin/sidebar";
import { initializeDeleteModalButton, cleanUpDeleteModalButton } from "admin/modal";
import { initPasswordToggles } from "admin/password_toggle";
import moment from "moment";
import flatpickr from "flatpickr";
importLazy("@popperjs/core");
importLazy("bootstrap");

import Highcharts from "highcharts";
// Load the exporting module.
import Exporting from "highcharts/modules/exporting";
// Initialize exporting module. (CommonJS only)
Exporting(Highcharts);

Rails.start();
Turbolinks.start();
ActiveStorage.start();

const componentRequireContext = require.context("components", true);
const ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

window.I18n = I18n;
window.moment = moment;
window.flatpickr = flatpickr;
window.Highcharts = Highcharts;
require("../../../public/javascripts/translations");
require("../styles/admin.css");

const initializeSidebar = (): void => {
  const toggleSidebarLink = document.querySelector("a.toggle-sidebar");
  const sidebar = document.querySelector("body");

  toggleSidebarLink?.addEventListener("click", (event) => toggleSidebar(sidebar, event));

  collapseActiveNavigation();
  loadSidebarState(sidebar);
};

const initialize = () => {
  try {
    initializeSidebar();
    initializeDeleteModalButton();
  } catch (error) {
    console.error(error);
  }
};

const cleanUp = () => {
  try {
    cleanUpDeleteModalButton();
  } catch (error) {
    console.error(error);
  }
};

document.addEventListener("turbolinks:load", initialize);
document.addEventListener("turbolinks:before-cache", cleanUp);

// Delegated, so it only needs to be wired once (not per turbolinks:load).
initPasswordToggles();
